import type { ToolsTreeNode, ToolsType } from "../../model/types";
import { tui } from "../locale";

export const disabledReason = (node: ToolsTreeNode, type: ToolsType): string | null =>
	node.selectable ? null : tui(`disabled-empty.${type}`);
